import { Job, JobStatusEnum } from 'graphql-common';

export default function isDeleteAllJobsAvailable(jobs: Job[]) {
  return !jobs.some(
    ({ status }) =>
      status === JobStatusEnum.Queued ||
      status === JobStatusEnum.Working ||
      status === JobStatusEnum.Retrying,
  );
}
